import { _ } from "../../../core/polyglot/polyglot.js";
import AbstractTextRepresentationSpecificationVisitor from "../../specification/visitors/AbstractTextRepresentationSpecificationVisitor.js";

/**
 * `TextRepresentationDimensionSpecificationVisitor` is used to display
 * dimension specifications in text form.
 *
 * @param {dimension} [spec.dimensionTree] - Dimension tree where dimension names are fetched
 */
export default class TextRepresentationDimensionSpecificationVisitor extends AbstractTextRepresentationSpecificationVisitor {
	constructor({ dimensionTree } = {}) {
		super(...arguments);
		this._dimensionTree = dimensionTree;
	}

	visitDimensionSpecification(aSpecification) {
		let dimension;

		if (this._dimensionTree) {
			dimension = this._dimensionTree.findById(
				aSpecification.getDimensionId(),
			);
		}

		return dimension
			? dimension.getLabel()
			: _("{id} (missing)", { id: aSpecification.getDimensionId() });
	}
}
